import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import EmailPassword from "supertokens-auth-react/recipe/emailpassword";
import Session from "supertokens-auth-react/recipe/session";
import { UserRoleClaim } from "supertokens-auth-react/recipe/userroles";
import { Box, TextField, Button, Link, Alert } from "@mui/material";

export default function InstructorAuthForm() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const response = await EmailPassword.signIn({
                formFields: [
                    { id: "email", value: email },
                    { id: "password", value: password },
                ],
            });
            if (response.status === "WRONG_CREDENTIALS_ERROR") {
                throw new Error("Incorrect email or password.");
            }

            if (await Session.doesSessionExist()) {
                const roles = await Session.getClaimValue({ claim: UserRoleClaim });
                if (roles && roles.includes("admin")) {
                    navigate("/admin");
                    return;
                }
            }
            
            navigate("/");
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
                {error && <Alert severity="error" sx={{ width: '100%', mt: 2, mb: 2, borderRadius: '12px' }}>{error}</Alert>}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ 
                        mt: 4, 
                        mb: 2,
                        py: 1.5,
                        borderRadius: '10px',
                        textTransform: 'none',
                        fontSize: '1rem',
                        fontWeight: 600,
                        boxShadow: 2,
                        '&:hover': {
                            boxShadow: 4
                        }
                    }}
                >
                    Sign In
                </Button>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', mt: 1 }}>
                    <Link variant="body2" onClick={() => navigate("/auth/reset-password")} sx={{ cursor: 'pointer', mb: 1, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
                        Forgot password?
                    </Link>
                    <Link 
                        href="#" 
                        variant="body2" 
                        onClick={(e) => {
                            e.preventDefault();
                            navigate("/signup");
                        }} 
                        sx={{ cursor: 'pointer', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                    >
                        Don't have an account? Sign Up
                    </Link>
                </Box>            </Box>
        </Box>
    );
}
